import { createContext, useContext, useMemo, type ReactNode } from "react";
import { config } from "../config.js";
import { useAuth } from "../auth/AuthContext.js";
import { createPortalClient, type PortalClient } from "./client.js";

/**
 * DI seam for the client, the same one as the Admin Dashboard's
 * createMetricsClient(baseUrl, getToken): tests inject a client and never touch the network.
 */
const Ctx = createContext<PortalClient | null>(null);

export function PortalClientProvider({
  children,
  client,
}: {
  children: ReactNode;
  client?: PortalClient;
}) {
  const auth = useAuth();
  const value = useMemo(
    () => client ?? createPortalClient(config.edgeBaseUrl, auth.getToken),
    [client, auth.getToken],
  );
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function usePortalClient(): PortalClient {
  const c = useContext(Ctx);
  if (!c) throw new Error("usePortalClient must be used inside <PortalClientProvider>");
  return c;
}
